const listSubscriptions = (request = {}) => {
    return new Promise((res, rej) => {
        axios.post('/merchantadmin/subscriptions/list', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const subscriptionHistory = (request) => {
    return new Promise((res, rej) => {
        axios.post('/merchantadmin/subscriptions/history', request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

export default {
    listSubscriptions,
    subscriptionHistory,
};
